/*
  http://bit.ly/2DTXGpe - `@babel/polyfill` has been deprecated.
  If you need to polyfill certain JS features, uncomment the two imports below.
*/
// import 'core-js/stable'
// import 'regenerator-runtime/runtime' // Needed to polyfill async / await.

// Import domain configuration
import { getDomainFromUrl, isDomainAllowed } from './config/domains';

// Get the main domain
const domainName = getDomainFromUrl();

// IMMEDIATELY apply domain class to body - do this BEFORE any other operations
const domainClass = `domain-${domainName.replace(/\./g, '-')}`;
document.body.className = domainClass; // Replace any existing classes
document.documentElement.className = domainClass; // Also add to HTML element

// Import shared styles
import './shared/assets/bootstrap/css/bootstrap.min.css'
import './shared/assets/font-awesome/css/font-awesome.min.css'
import './shared/assets/simple-line-icons/css/simple-line-icons.css'
import './shared/styles/jquery-ui.css'

// Import domain-specific module (which imports the CSS)
const loadDomainAssets = async () => {
  let moduleLoaded = false;

  // First, try to load the domain's index.js file
  try {
    await import(`./domains/${domainName}/index.js`);
    moduleLoaded = true;
  } catch (e) {
    console.warn(`No index.js found for ${domainName}, will try direct CSS import`);
  }

  // If the module didn't load or doesn't exist, try loading the CSS directly
  if (!moduleLoaded) {
    try {
      await import(`./domains/${domainName}/styles/custom.css`);
      moduleLoaded = true;
    } catch (e) {
      console.warn(`No custom CSS found for ${domainName}, using default`);
      
      // Fall back to default CSS if domain-specific CSS not found
      try {
        await import('./shared/styles/custom.css');
      } catch (defaultError) {
        console.error('Error loading default CSS:', defaultError);
      }
    }
  }
};

// Execute the loading function
loadDomainAssets();

// Import the appropriate JSON data
let data;
try {
  data = require(`./domains/${domainName}/content/data.json`);
} catch (e) {
  console.warn(`No content found for ${domainName}, using default`);
  data = require('./domains/financial-money.com/content/data.json');
}

// Optional per-domain privacy/terms HTML (falls back to shared templates)
import { loadLegalHtml } from './helpers/legalContent'
const { privacyHtml, termsHtml } = loadLegalHtml(domainName)

// Import React.
import React from 'react'
import { createRoot } from 'react-dom/client'

// Import our components.
import Home from './components/Home'
import NotFound from './components/NotFound'
import Terms from './components/Terms'
import PrivacyPolicy from './components/PrivacyPolicy'

// Import React Router things.
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Header from './components/Header'

// Top-level classes on the body. Feel free to remove / change.
// document.body.className = 'bg-black-80 fw4 white-80'

// Get the root element
const container = document.querySelector('#app')
const root = createRoot(container)

// Mount our app.
root.render(
  <>
    {/* Hidden div to ensure PurgeCSS keeps all icon classes */}
    <div style={{display: 'none'}}>
      icon-check icon-clock icon-user-follow icon-lock icon-user icon-people icon-user-female icon-login icon-logout icon-emotsmile icon-phone icon-call-end icon-call-in icon-call-out icon-map icon-location-pin icon-direction icon-directions icon-compass icon-layers icon-menu icon-list icon-options-vertical icon-options icon-arrow-down icon-arrow-left icon-arrow-right icon-arrow-up icon-arrow-up-circle icon-arrow-left-circle icon-arrow-right-circle icon-arrow-down-circle icon-plus icon-minus icon-close icon-exclamation icon-organization icon-trophy icon-screen-smartphone icon-screen-desktop icon-plane icon-notebook icon-mustache icon-mouse icon-magnet icon-energy icon-disc icon-cursor icon-cursor-move icon-crop icon-chemistry icon-speedometer icon-shield icon-screen-tablet icon-magic-wand icon-hourglass icon-graduation icon-ghost icon-game-controller icon-fire icon-eyeglass icon-envelope-open icon-envelope-letter icon-bell icon-badge icon-anchor icon-wallet icon-vector icon-speech icon-puzzle icon-printer icon-present icon-playlist icon-pin icon-picture icon-handbag icon-globe-alt icon-globe icon-folder-alt icon-folder icon-film icon-feed icon-drop icon-drawer icon-docs icon-doc icon-diamond icon-cup icon-calculator icon-bubbles icon-briefcase icon-book-open icon-basket-loaded icon-basket icon-bag icon-action-undo icon-action-redo icon-wrench icon-umbrella icon-trash icon-tag icon-support icon-frame icon-size-fullscreen icon-size-actual icon-shuffle icon-share-alt icon-share icon-rocket icon-question icon-pie-chart icon-pencil icon-note icon-loop icon-home icon-grid icon-graph icon-microphone icon-music-tone-alt icon-music-tone icon-earphones-alt icon-earphones icon-equalizer icon-like icon-dislike icon-control-start icon-control-rewind icon-control-play icon-control-pause icon-control-forward icon-control-end icon-volume-1 icon-volume-2 icon-volume-off icon-calendar icon-bulb icon-chart icon-ban icon-bubble icon-camrecorder icon-camera icon-cloud-download icon-cloud-upload icon-envelope icon-eye icon-flag icon-heart icon-info icon-key icon-link icon-lock icon-lock-open icon-magnifier icon-magnifier-add icon-magnifier-remove icon-paper-clip icon-paper-plane icon-power icon-refresh icon-reload icon-settings icon-star icon-symbol-female icon-symbol-male icon-target icon-credit-card icon-paypal icon-social-tumblr icon-social-twitter icon-social-facebook icon-social-instagram icon-social-linkedin icon-social-pinterest icon-social-github icon-social-google icon-social-reddit icon-social-skype icon-social-dribbble icon-social-behance icon-social-foursqare icon-social-soundcloud icon-social-spotify icon-social-stumbleupon icon-social-youtube icon-social-dropbox
    </div>
    <BrowserRouter>
      <Header 
        data={data}
        showExploreOptions={data.showExploreOptionsButton !== false}
        showWhyChooseUs={data.showWhyChooseUsButton !== false}
        exploreOptionsButtonText={data.exploreOptionsButtonText}
        whyChooseUsButtonText={data.whyChooseUsButtonText}
      />
      <Routes>
        <Route path="/" element={<Home data={data} />} />
        <Route path="/terms" element={<Terms data={data} html={termsHtml} />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy data={data} html={privacyHtml} />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  </>
)
